const formatCount = (value) =>
    new Intl.NumberFormat().format(value);

const updateAnnouncementCount = (input) => {
    const container =
        input.closest(
            '.md\\:col-span-2'
        )
        ?? input.parentElement;

    const counter =
        container?.querySelector(
            '[data-announcement-count]'
        );

    if (! counter) {
        return;
    }

    const max =
        Number(input.maxLength);

    const current =
        input.value.length;

    counter.textContent =
        `${formatCount(current)} / ${formatCount(max)}`;

    counter.classList.toggle(
        'text-amber-600',
        max > 0
        && current >= max * 0.9
        && current < max
    );

    counter.classList.toggle(
        'text-rose-600',
        max > 0
        && current >= max
    );
};

const readableDate = (value) => {
    if (! value) {
        return null;
    }

    const date =
        new Date(value);

    if (
        Number.isNaN(
            date.getTime()
        )
    ) {
        return null;
    }

    return date.toLocaleString(
        undefined,
        {
            dateStyle: 'medium',
            timeStyle: 'short',
        }
    );
};

const updateAnnouncementStatus = (form) => {
    const status =
        form.querySelector(
            '[data-announcement-status]'
        );

    const publishedAt =
        form.querySelector(
            '[data-announcement-published-at]'
        );

    const expiresAt =
        form.querySelector(
            '[data-announcement-expires-at]'
        );

    const feedback =
        form.querySelector(
            '[data-announcement-status-feedback]'
        );

    if (
        ! status
        || ! feedback
    ) {
        return;
    }

    const publishText =
        readableDate(
            publishedAt?.value
        );

    const expireText =
        readableDate(
            expiresAt?.value
        );

    let message = '';

    if (
        status.value
        === 'draft'
    ) {
        message =
            'Draft: this announcement will stay private until you change its status to Published.';
    } else if (
        status.value
        === 'unpublished'
    ) {
        message =
            'Unpublished: this announcement will remain hidden from attendees.';
    } else if (
        status.value
        === 'published'
        && publishText
        && new Date(
            publishedAt.value
        ) > new Date()
    ) {
        message =
            `Scheduled: this announcement will become public on ${publishText}.`;
    } else {
        message =
            'Published: this announcement will become public immediately when saved.';
    }

    if (expireText) {
        message +=
            ` It will stop appearing publicly after ${expireText}.`;
    }

    feedback.textContent =
        message;
};

const initializeAnnouncementForms = () => {
    document
        .querySelectorAll(
            '[data-announcement-form]'
        )
        .forEach((form) => {
            form
                .querySelectorAll(
                    '[data-announcement-count-input]'
                )
                .forEach((input) => {
                    updateAnnouncementCount(input);

                    input.addEventListener(
                        'input',
                        () =>
                            updateAnnouncementCount(
                                input
                            )
                    );
                });

            [
                '[data-announcement-status]',
                '[data-announcement-published-at]',
                '[data-announcement-expires-at]',
            ].forEach((selector) => {
                form
                    .querySelector(selector)
                    ?.addEventListener(
                        'change',
                        () =>
                            updateAnnouncementStatus(
                                form
                            )
                    );
            });

            updateAnnouncementStatus(
                form
            );
        });
};

if (
    document.readyState
    === 'loading'
) {
    document.addEventListener(
        'DOMContentLoaded',
        initializeAnnouncementForms
    );
} else {
    initializeAnnouncementForms();
}
